import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Wrapper,
  Container,
  Title,
  SubTitle,
  InputsContainer,
  ButtonContainer,
  ButtonsContainer,
} from "./styled";
import { SUB_TITLE, TITLE } from "./constants";
import GenericInput from "../../../../commons/Buttons/Inputs/GenericInput";
import LabelOnlyButton from "../../../../commons/Buttons/LabelOnlyButton";
import { editUser, getProfiles } from "../../../../../store/BackOffice/actions";
import {
  profiles,
  userPendingList,
  userUid,
} from "../../../../../store/BackOffice/selectors";
import { getUserByUid } from "../../functions";
import GenericSelect from "../../../../commons/GenericSelect";
import colors from "../../../../../styles/colors";
import { Dialog } from "@material-ui/core";
import { selectModal } from "../../../../../store/Modals/selectors";
import { MODAL_ACCEPT_USER } from "../../../../../store/Modals/constants";
import { closeModal } from "../../../../../store/Modals/actions";

const AcceptUser = () => {
  const dispatch = useDispatch();
  const users = useSelector(userPendingList);
  const uid = useSelector(userUid);
  const [disabled, setDisabled] = useState(true);
  const show = useSelector((state) => selectModal(state, MODAL_ACCEPT_USER));
  const profilesList = useSelector(profiles);
  const [newUser, setNewUser] = useState({
    name: getUserByUid(uid, users).name,
    email: getUserByUid(uid, users).mail,
    password: getUserByUid(uid, users).password,
    profile: getUserByUid(uid, users).profile,
  });

  const handleChange = (e) => {
    setNewUser({
      ...newUser,
      [e.target.name]: e.target.value,
    });
  };

  const modifyUser = () => {
    dispatch(editUser(newUser));
  };

  useEffect(() => {
    if (
      newUser.name !== null &&
      newUser.name !== "" &&
      newUser.email !== null &&
      newUser.email !== "" &&
      newUser.profile !== null &&
      newUser.profile !== ""
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newUser]);

  useEffect(() => {
    dispatch(getProfiles());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!show) {
    return null;
  }

  return (
    <Dialog
      open
      onClose={() => dispatch(closeModal(MODAL_ACCEPT_USER))}
      fullWidth
    >
      <Wrapper>
        <Container>
          <Title>{TITLE}</Title>
          <SubTitle>{SUB_TITLE}</SubTitle>
          <InputsContainer>
            <GenericInput
              name="name"
              handleChange={handleChange}
              placeholder="Nombre"
              value={newUser.name}
            />
            <GenericInput
              name="email"
              handleChange={handleChange}
              placeholder="Email"
              value={newUser.email}
            />
            <GenericInput
              name="password"
              handleChange={handleChange}
              placeholder="Contraseña"
              type={"password"}
              value={newUser.password}
            />
            <GenericSelect
              name="profile"
              handleChange={handleChange}
              placeholder="Perfil"
              value={newUser.profile}
              options={profilesList}
            />
            <ButtonsContainer>
              <ButtonContainer disabled={disabled}>
                <LabelOnlyButton
                  onClick={modifyUser}
                  label={"Aceptar"}
                  color={colors.white2}
                  background={colors.orange1}
                />
              </ButtonContainer>
              <ButtonContainer>
                <LabelOnlyButton
                  onClick={() => dispatch(closeModal(MODAL_ACCEPT_USER))}
                  label={"Cancelar"}
                  color={colors.white2}
                  background={colors.blue3}
                />
              </ButtonContainer>
            </ButtonsContainer>
          </InputsContainer>
        </Container>
      </Wrapper>
    </Dialog>
  );
};

export default AcceptUser;
